"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90],{

/***/ 31079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCabin = function SvgCabin(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.284 11.852C44.758 7.387 40.39 6.037 36.67 5.798A11.162 11.162 0 0 0 26.843 0a11.16 11.16 0 0 0-7.908 3.246c-3.087 3.059-4.08 7.505-2.638 11.529L1.609 29.33c-.198.196-.321.454-.348.73l-.255 2.578c-.035.357.092.71.348.963l3.201 3.173c.2.198.462.32.743.345l1.353.124a1.214 1.214 0 0 0 .964-.345l2.465-2.444c.227-.224.354-.529.354-.846v-.246h.248c.32 0 .627-.126.854-.35l.485-.481c.226-.225.354-.53.354-.847v-1.873h1.89c.32 0 .628-.126.854-.35l1.705-1.69a1.19 1.19 0 0 0 .353-.846v-.147h.149c.32 0 .627-.126.854-.35l1.58-1.567c.227-.224.354-.529.354-.846v-.493h.497c.32 0 .627-.126.854-.35l1.654-1.64c1.195.42 2.445.631 3.728.631 2.986 0 5.793-1.152 7.904-3.244a11.02 11.02 0 0 0 2.92-10.591c2.803.394 5.765 1.615 7.507 4.693 3.076 5.437.402 10.25-1.115 12.306l-7.874-1.694c-.4-.086-.82.035-1.11.324l-13.874 13.75a1.191 1.191 0 0 0 0 1.692l10.342 10.25c.236.233.545.35.854.35.31 0 .618-.117.854-.35L47.13 35.9a1.19 1.19 0 0 0 .326-1.1l-1.695-7.739a16.709 16.709 0 0 0 2.195-3.792c1.592-3.877 1.36-7.825-.672-11.417ZM30.278 10.76c-.83 0-1.61-.32-2.198-.902a3.064 3.064 0 0 1 0-4.355 3.102 3.102 0 0 1 2.198-.902A3.102 3.102 0 0 1 32.812 5.9c-1.608.18-2.707.468-2.853.508a1.195 1.195 0 0 0-.846 1.47c.176.638.84 1.013 1.484.838.033-.009 1.128-.296 2.732-.45a3.104 3.104 0 0 1-3.051 2.493Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCabin);

/***/ }),

/***/ 29324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M47 21H3c-1.2 0-2 .833-2 2.083v4.167c0 1.25.8 2.083 2 2.083h44c1.2 0 2-.833 2-2.083v-4.167c0-1.25-.8-2.083-2-2.083z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgMinus);

/***/ }),

/***/ 25863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M47.917 20.833H30.208c-.625 0-1.041-.416-1.041-1.041V2.083C29.167.833 28.333 0 27.083 0h-4.166c-1.25 0-2.084.833-2.084 2.083v17.709c0 .625-.416 1.041-1.041 1.041H2.083c-1.25 0-2.083.834-2.083 2.084v4.166c0 1.25.833 2.084 2.083 2.084h17.709c.625 0 1.041.416 1.041 1.041v17.709c0 1.25.834 2.083 2.084 2.083h4.166c1.25 0 2.084-.833 2.084-2.083V30.208c0-.625.416-1.041 1.041-1.041h17.709c1.25 0 2.083-.834 2.083-2.084v-4.166c0-1.25-.833-2.084-2.083-2.084Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgPlus);

/***/ }),

/***/ 95559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    clipPath: "url(#star_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m13.44 1.586 1.931 5.983a.814.814 0 0 0 .303.421c.14.101.31.16.496.16l6.287-.014c.335 0 .642.103.893.285.253.184.446.444.55.76.103.319.1.644.004.94-.099.296-.287.56-.556.755l-5.095 3.687a.823.823 0 0 0-.305.937l1.956 5.977a1.505 1.505 0 0 1-.55 1.695 1.509 1.509 0 0 1-.89.291c-.312 0-.621-.098-.89-.293l-5.08-3.707A.85.85 0 0 0 12 19.3a.847.847 0 0 0-.493.162l-5.08 3.707a1.504 1.504 0 0 1-1.78.002 1.505 1.505 0 0 1-.55-1.695L6.05 15.5a.826.826 0 0 0-.303-.937L.652 10.876c-.269-.195-.46-.46-.556-.755a1.512 1.512 0 0 1 .005-.94c.103-.316.296-.576.549-.76.251-.182.558-.285.892-.285l6.288.014a.827.827 0 0 0 .798-.58l1.931-5.984c.103-.316.296-.579.547-.762.254-.184.563-.287.893-.287.332 0 .641.103.895.287.25.184.444.446.547.762Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "star_svg__a"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgStar);

/***/ }),

/***/ 53242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ Highlightbar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./src/components/atoms/labelled-arrow/labelled-arrow.tsx + 1 modules
var labelled_arrow = __webpack_require__(27240);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/highlightbar/highlightbar.style.tsx





var _templateObject;

var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var StyledExclusivesOuterWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref) {
  var color = _ref.color,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread({}, rest));
},  true ? {
  target: "eo7pqjv3"
} : 0)("color:", function (props) {
  return props.color;
}, ";.highlightBarCard{padding:0;margin:0 0 15px;width:auto;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin:0 auto 15px;}}" + ( true ? "" : 0));
var StyledExclusivesInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eo7pqjv2"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";border:1px solid ", function (props) {
  return props.color;
}, ";width:265px;margin:0 auto;padding:12px;display:flex;", global_style/* media.tablet */.BC.tablet(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        padding: 20px 20px 10px;\n        width: 100%;\n    "]))), ";" + ( true ? "" : 0));
var StyledArrowText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eo7pqjv1"
} : 0)("padding:0 9px;font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";" + ( true ? "" : 0));
var StyledLabelledArrowWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eo7pqjv0"
} : 0)("position:relative;top:11px;z-index:1;display:flex;justify-content:center;align-items:center;color:", function (props) {
  return props.theme.shades.white;
}, ";font-weight:500;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/atoms/highlightbar/highlightbar.tsx






var Highlightbar = function Highlightbar(_ref) {
  var headline = _ref.headline,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? global_style/* theme.colors.main4 */.rS.colors.main4 : _ref$color,
      className = _ref.className,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledExclusivesOuterWrapper, {
    color: color,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabelledArrowWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(labelled_arrow/* LabelledArrow */.F, {
        left: true,
        right: true,
        backgroundColor: color,
        heightBox: 22,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledArrowText, {
          children: headline
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledExclusivesInnerWrapper, {
      className: className,
      children: children
    })]
  });
};

/***/ }),

/***/ 56820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mv": function() { return /* binding */ StyledIconWrapper; },
/* harmony export */   "SD": function() { return /* binding */ StyledWrapper; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61516);
/* harmony import */ var _style_global_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43780);



var _templateObject, _templateObject2, _templateObject3;


var StyledListItem = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("li",  true ? {
  target: "eqouvwu2"
} : 0)("display:flex;align-items:baseline;", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .media.tablet */ .BC.tablet(_templateObject || (_templateObject = (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n        width: 33%;\n        padding: 5px 0;\n    "]))), " span{margin-left:10px;font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";font-weight:700;font-style:normal;font-stretch:normal;line-height:1.69;letter-spacing:normal;word-break:break-word;@media ", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.tablet */ .w5.tablet, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";line-height:1.47;}}" + ( true ? "" : 0));
var StyledWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ul",  true ? {
  target: "eqouvwu1"
} : 0)("display:flex;flex-direction:column;list-style:none;padding-left:0;margin-bottom:0;color:", function (props) {
  return props.color;
}, ";", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .media.tablet */ .BC.tablet(_templateObject2 || (_templateObject2 = (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n        flex-direction: row;\n        flex-wrap: wrap;\n        align-items: flex-start;\n        justify-content: space-between;\n    "]))), ";" + ( true ? "" : 0));
var StyledIconWrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "eqouvwu0"
} : 0)("height:22px;width:22px;transform:translateY(2px);", _style_global_style__WEBPACK_IMPORTED_MODULE_1__/* .media.tablet */ .BC.tablet(_templateObject3 || (_templateObject3 = (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n        height: 25px;\n        width: 25px;\n    "]))), ";" + ( true ? "" : 0));

/***/ }),

/***/ 67250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$H": function() { return /* binding */ BestpriceIcon; },
  "Ol": function() { return /* binding */ CheckMarkIcon; },
  "Fu": function() { return /* binding */ ExpertIcon; },
  "Og": function() { return /* binding */ GiftIcon; },
  "$0": function() { return /* binding */ StyledArrowIcon; },
  "Ft": function() { return /* binding */ StyledArrowText; },
  "Ll": function() { return /* binding */ StyledComponentWrapper; },
  "a0": function() { return /* binding */ StyledExclusivesInnerWrapper; },
  "zp": function() { return /* binding */ StyledExclusivesOuterWrapper; },
  "Ej": function() { return /* binding */ StyledHighlightInnerWrapper; },
  "lW": function() { return /* binding */ StyledLabelledArrowWrapper; }
});

// UNUSED EXPORTS: StyledShowMoreBtn

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
;// CONCATENATED MODULE: ./public/static/icons/gift.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M14.022 2.844c.54 0 .978.429.978.957v1.435a.484.484 0 0 1-.49.478H.49A.484.484 0 0 1 0 5.236V3.8c0-.528.438-.957.978-.957h1.089a1.674 1.674 0 0 1-.266-.737A1.876 1.876 0 0 1 2.945.167a1.952 1.952 0 0 1 2.09.329l1.38 1.223a1.484 1.484 0 0 1 2.168-.001L9.962.496a1.95 1.95 0 0 1 2.09-.33 1.876 1.876 0 0 1 1.144 1.94 1.675 1.675 0 0 1-.266.738h1.092zm-7.99-.16.001-.013-1.654-1.467a.958.958 0 0 0-1.054-.156.944.944 0 0 0-.528.623.95.95 0 0 0 .935 1.173h2.3v-.16zm6.193-.704c.034-.464-.239-.851-.704-.987-.324-.094-.675.01-.925.231L8.967 2.668v.177h2.253c.51 0 .969-.368 1.005-.865zM.715 6.429h5.714V15H1.723c-.557 0-1.009-.46-1.009-1.029V6.43zm7.856 0h5.715v7.542c0 .569-.452 1.029-1.009 1.029H8.571V6.429z"
  })));
};

/* harmony default export */ var gift = (SvgGift);
// EXTERNAL MODULE: ./public/static/arrow.svg
var arrow = __webpack_require__(59846);
;// CONCATENATED MODULE: ./public/static/icons/expert.svg
var expert_path;

function expert_extends() { expert_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return expert_extends.apply(this, arguments); }



var SvgExpert = function SvgExpert(props) {
  return /*#__PURE__*/react.createElement("svg", expert_extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), expert_path || (expert_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.969 12.482c1.365 0 2.53-.488 3.502-1.459.97-.97 1.459-2.142 1.459-3.502 0-1.365-.489-2.54-1.46-3.531-.97-.992-2.137-1.49-3.501-1.49-1.365 0-2.53.498-3.502 1.49-.97.99-1.46 2.172-1.46 3.531 0 1.365.49 2.531 1.46 3.502.971.971 2.142 1.46 3.502 1.46Zm6.57 2.715c-2.277-.916-4.468-1.374-6.57-1.374-2.103 0-4.29.458-6.572 1.374-.174.07-.339.14-.493.215l.688 1.63 4.717.402c.095.01.175.07.204.165.03.09 0 .19-.07.254l-3.58 3.104.537 2.316h14.546V18.8c.005-1.49-1.13-2.684-3.407-3.601v-.002Zm-15.01-1.19 1.505 3.547h-.001c.034.075.1.124.174.13l3.85.328-2.918 2.53a.213.213 0 0 0-.07.21l.877 3.766-3.308-1.998a.216.216 0 0 0-.219 0l-3.307 1.998.876-3.766a.217.217 0 0 0-.07-.21L0 18.013l3.85-.328a.216.216 0 0 0 .175-.13l1.505-3.547Z"
  })));
};

/* harmony default export */ var expert = (SvgExpert);
// EXTERNAL MODULE: ./public/static/icons/checkMark.svg
var checkMark = __webpack_require__(60742);
;// CONCATENATED MODULE: ./public/static/icons/bestprice.svg
var bestprice_path;

function bestprice_extends() { bestprice_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bestprice_extends.apply(this, arguments); }



var SvgBestprice = function SvgBestprice(props) {
  return /*#__PURE__*/react.createElement("svg", bestprice_extends({
    viewBox: "0 0 17 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), bestprice_path || (bestprice_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.966 8.725-.853-1.495.47-1.655-1.373-1.059L15 2.814l-1.681-.463-.854-1.495-1.729.203L9.363 0 7.844.84 6.164.377 5.088 1.73l-1.73.207-.47 1.655-1.518.84.206 1.702L.5 7.474l.854 1.495-.47 1.655 1.372 1.058.21 1.703 1.682.462.848 1.501 1.73-.202 1.372 1.058 1.52-.84 1.68.463 1.075-1.351 1.73-.208.47-1.654 1.519-.84-.206-1.703 1.081-1.346Zm-8.231 5.203c-3.27 0-5.923-2.613-5.923-5.83 0-3.219 2.654-5.831 5.923-5.831 3.27 0 5.923 2.612 5.923 5.83 0 3.219-2.654 5.831-5.923 5.831ZM3.39 8.097c0-2.9 2.4-5.262 5.345-5.262s5.345 2.362 5.345 5.262c0 2.898-2.4 5.261-5.345 5.261S3.39 10.996 3.39 8.097Zm4.972 2.953h1.21V4.816H8.59c-.14.378-.394.712-.762.995-.368.287-.713.479-1.027.58V7.47c.6-.197 1.119-.5 1.562-.905v4.485Zm1.914 5.203 1.27.351 1.146-1.436.292-.037 2.502 8.576-2.654-.601L10.908 25l-1.583-5.443.95-3.303Zm-3.682-.383 1.465 1.128 1.615-.9.092.027-.762 2.34-1.902 6.533-1.924-1.894-2.648.602 2.297-7.629 1.767-.207Z"
  })));
};

/* harmony default export */ var bestprice = (SvgBestprice);
// EXTERNAL MODULE: ./src/components/atoms/icon-list/icon-list.style.tsx
var icon_list_style = __webpack_require__(56820);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/sections/highlights/highlights.style.tsx




var _excluded = ["isCollapsed"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var StyledComponentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1x9h30x11"
} : 0)("color:", function (props) {
  return props.theme.colors.black;
}, ";margin:0 auto;max-width:100%;@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{margin:0 auto;max-width:calc(100% - 30px);}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{max-width:calc(100% - 30px);padding-top:60px;padding-bottom:30px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{max-width:1170px;}" + ( true ? "" : 0));
var StyledExclusivesOuterWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x9h30x10"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";", global_style/* media.tablet */.BC.tablet(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        background-color: transparent;\n    "]))), ";" + ( true ? "" : 0));
var StyledHighlightInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x9h30x9"
} : 0)("width:100%;margin:0 auto;", global_style/* media.tablet */.BC.tablet(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n        margin: 0 auto;\n        width: 100%;\n    "]))), ";" + ( true ? "" : 0));
var StyledExclusivesInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x9h30x8"
} : 0)("background-color:rgba(0, 98, 149, 0.1);width:100%;margin:0 auto;padding:12px 20%;", icon_list_style/* StyledListItem */.oH, "{span{font-size:14px;}}", icon_list_style/* StyledWrapper */.SD, "{padding-top:10px;}", global_style/* media.tablet */.BC.tablet(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n        padding: 12px;\n    "]))), "@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{padding:12px 25px;", icon_list_style/* StyledListItem */.oH, "{span{font-size:15px;}}}" + ( true ? "" : 0));
var StyledShowMoreBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1x9h30x7"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";color:", function (props) {
  return props.theme.colors.main4;
}, ";font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";font-weight:700;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;padding:15px 0 15px 0;margin:0;display:flex;align-items:center;justify-content:center;border:none;width:100%;", global_style/* media.smallDesktop */.BC.smallDesktop(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n        display: none;\n    "]))), ";" + ( true ? "" : 0));
var StyledArrowIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref) {
  var isCollapsed = _ref.isCollapsed,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow/* default */.Z, _objectSpread({}, rest));
},  true ? {
  target: "e1x9h30x6"
} : 0)("width:12px;height:12px;margin-left:5px;stroke-width:2;fill:", function (props) {
  return props.theme.colors.main4;
}, ";transform:", function (props) {
  return props.isCollapsed ? "rotate(90deg)" : "rotate(-90deg)";
}, ";" + ( true ? "" : 0));
var StyledLabelledArrowWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x9h30x5"
} : 0)("position:relative;top:0;padding:5px 0;z-index:1;display:flex;justify-content:center;align-items:center;color:", function (props) {
  return props.theme.shades.white;
}, ";background-color:", function (props) {
  return props.theme.labels.onlineBookable;
}, ";font-weight:500;font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";" + ( true ? "" : 0));
var StyledArrowText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1x9h30x4"
} : 0)( true ? {
  name: "5nfxuy",
  styles: "padding:0 9px"
} : 0);
var GiftIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(gift,  true ? {
  target: "e1x9h30x3"
} : 0)("fill:", function (props) {
  return props.theme.labels.onlineBookable;
}, ";height:inherit;width:inherit;" + ( true ? "" : 0));
var CheckMarkIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(checkMark/* default */.Z,  true ? {
  target: "e1x9h30x2"
} : 0)("fill:", function (props) {
  return props.theme.labels.onlineBookable;
}, ";height:20px;width:20px;" + ( true ? "" : 0));
var ExpertIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(expert,  true ? {
  target: "e1x9h30x1"
} : 0)("fill:", function (props) {
  return props.theme.labels.onlineBookable;
}, ";height:inherit;width:inherit;" + ( true ? "" : 0));
var BestpriceIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(bestprice,  true ? {
  target: "e1x9h30x0"
} : 0)("fill:", function (props) {
  return props.theme.labels.onlineBookable;
}, ";height:inherit;width:inherit;" + ( true ? "" : 0));

/***/ }),

/***/ 99805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hz": function() { return /* binding */ getUGCPropsFromData; }
/* harmony export */ });
/* unused harmony exports getUGCRequest, getUGCSubpageRequest */
/* harmony import */ var _app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _api_resources__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15206);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16645);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74194);
/* harmony import */ var _utils_translation_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21449);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var getUGCRequest = function getUGCRequest(args) {
  var request = args.request;
  var ugc = {
    name: 'ugcHeader',
    includeFilters: {
      id: request.id,
      type: request.mainType
    },
    sortBy: 'quote',
    limit: 3,
    fields: [{
      name: 'aggregation',
      fields: [{
        name: 'data',
        fields: [{
          name: 'attributes',
          fields: ['overall', 'reviewClass', 'numRatings']
        }]
      }]
    }, {
      name: 'rating',
      fields: [{
        name: 'data',
        fields: [{
          name: 'attributes',
          fields: ['positivePointsComment', 'name', 'departure', 'ship', 'cruise']
        }]
      }]
    }]
  };
  request.translations = [].concat(_toConsumableArray(request.translations), ['ugcExcellent', 'ugcAverage', 'ugcOk', 'ugcGood', 'ugcVeryGood', 'ugcUSPHeadline', 'ugcHeadline', 'ugcSubpageButton', 'ugcUSP1', 'ugcUSP2', 'ugcUSP3', 'additionalReviewInfo']);
  request.ugc.push(ugc);
  return request;
};
var getUGCSubpageRequest = function getUGCSubpageRequest(args) {
  var request = args.request;
  var requestNew = getUGCRequest(args);
  var ugc = {
    name: 'ugcSubpage',
    includeFilters: {
      id: request.id,
      type: request.mainType
    },
    sortBy: 'date_desc',
    offset: 0,
    limit: 10,
    fields: [{
      name: 'aggregation',
      fields: [{
        name: 'data',
        fields: [{
          name: 'attributes',
          fields: ['overall', 'reviewClass', 'numRatings', 'shipRating', 'cabinRating', 'gastronomyRating', 'excursionsRating', 'serviceRating', 'sportRating', 'entertainmentRating', {
            name: 'reviewClasses',
            fields: ['reviewClass', 'count', 'rating', 'suffix']
          }]
        }]
      }]
    }, {
      name: 'rating',
      fields: [{
        name: 'data',
        fields: [{
          name: 'attributes',
          fields: ['name', 'constellation', 'positivePointsComment', 'negativePointsComment', 'cabinComment', 'atmosphere', 'overallRating', 'cruise', 'arrival', 'ageRange', 'cabinType']
        }]
      }]
    }]
  };
  requestNew.ugc.push(ugc);

  if (request.mainType === 'destination') {
    var topHarboursQuery = {
      name: 'topHarbours',
      fields: [{
        name: 'items',
        fields: ['title', 'rating']
      }],
      includeFilters: {
        regionIds: [String(request.id)]
      },
      limit: 10,
      sortBy: 'relevance'
    };
    requestNew.harbourSearches.push(topHarboursQuery);
  }

  requestNew.translations = [].concat(_toConsumableArray(requestNew.translations), ['ugcShip', 'ugcCabin', 'ugcGastronomy', 'ugcExcursions', 'ugcService', 'ugcSport', 'ugcEntertainment', 'atmosphereboring', 'atmospherechaotic', 'atmospherediverse', 'atmospherefamiliar', 'atmosphereelegant', 'atmosphererelaxed', 'atmosphereloud', 'constellationcoupleLabel', 'constellationfamilyLabel', 'constellationfamilysmallchildrenLabel', 'constellationfriendsLabel', 'constellationsingleLabel', 'loadMore', 'additionalReviewInfo']);
  return requestNew;
};

var getMoreUGCReviewsByShipSlug = function getMoreUGCReviewsByShipSlug(shipSlug) {
  return function (offset, itemsToFetch) {
    return (0,_api_resources__WEBPACK_IMPORTED_MODULE_1__/* .fetchUGC */ .yh)({
      slug: shipSlug,
      offset: offset,
      limit: itemsToFetch
    }).then(function (data) {
      var _data$rating;

      return (_data$rating = data.rating) === null || _data$rating === void 0 ? void 0 : _data$rating.data;
    });
  };
};

var getUGCPropsFromData = function getUGCPropsFromData(_ref) {
  var modulesData = _ref.modulesData,
      getLandingPage = _ref.getLandingPage,
      shipSlug = _ref.slug,
      ugcSlug = _ref.ugcSlug,
      subpage = _ref.subpage;
  var ugcHeader = modulesData["ugcData"];

  if (!ugcHeader || !ugcHeader.aggregation || !ugcHeader.rating) {
    _utils_logger__WEBPACK_IMPORTED_MODULE_3__/* .log.warn */ .c.warn('getUGCProps called without data');
    return undefined;
  }

  var _ugcHeader$aggregatio = ugcHeader.aggregation.data.attributes,
      overall = _ugcHeader$aggregatio.overall,
      reviewClass = _ugcHeader$aggregatio.reviewClass,
      numRatings = _ugcHeader$aggregatio.numRatings;
  var review = reviewClass ? reviewClass.replace(' ', '') : '';
  var testimonials = ugcHeader.rating.data.map(function (item) {
    return {
      quote: item.attributes.positivePointsComment,
      name: item.attributes.name,
      additionalInfo: getLandingPage.title,
      time: item.attributes.departure ? (0,_utils_date__WEBPACK_IMPORTED_MODULE_2__/* .formatDateToNamedMonthAndYear */ .zv)(item.attributes.departure.split('T')[0]) : ''
    };
  }).slice(0, 3);

  var ratingString = (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugc' + review);

  var subpageProps = {};

  if (numRatings >= 5 && !subpage) {
    subpageProps = {
      href: "".concat(getLandingPage.url, "/").concat(ugcSlug),
      buttonText: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcSubpageButton')
    };
  } else if (subpage) {
    var ugcData = modulesData["ugcData"];

    if (!ugcData || !ugcData.aggregation || !ugcData.rating) {
      throw new Error('getUGCProps for subpage called without data ');
    }

    var _ugcData$aggregation$ = ugcData.aggregation.data.attributes,
        reviewClasses = _ugcData$aggregation$.reviewClasses,
        shipRating = _ugcData$aggregation$.shipRating,
        cabinRating = _ugcData$aggregation$.cabinRating,
        gastronomyRating = _ugcData$aggregation$.gastronomyRating,
        excursionsRating = _ugcData$aggregation$.excursionsRating,
        serviceRating = _ugcData$aggregation$.serviceRating,
        sportRating = _ugcData$aggregation$.sportRating,
        entertainmentRating = _ugcData$aggregation$.entertainmentRating;
    var ratingRanges = reviewClasses.map(function (item) {
      return {
        value: item.count,
        description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugc' + item.reviewClass.replace(' ', '')) + ' ' + item.suffix
      };
    }).reverse();
    var detailRatings = getLandingPage.type === 'destination' && modulesData['harbourSearchtopHarbours'] ? // For destination we want to show the harbours and not the ship/cabin et al. rating
    modulesData['harbourSearchtopHarbours'].items.filter(function (item) {
      return !!item.rating;
    }).map(function (item) {
      return {
        value: item.rating.toFixed(1),
        description: item.title
      };
    }) : [{
      value: shipRating,
      description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcShip')
    }, {
      value: cabinRating,
      description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcCabin')
    }, {
      value: gastronomyRating,
      description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcGastronomy')
    }, {
      value: excursionsRating,
      description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcExcursions')
    }, {
      value: serviceRating,
      description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcService')
    }, {
      value: sportRating,
      description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcSport')
    }, {
      value: entertainmentRating,
      description: (0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcEntertainment')
    }].map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        value: item.value && typeof item.value === 'number' ? item.value.toFixed(1) : item.value || null
      });
    });
    var reviews = ugcData.rating.data;
    subpageProps = {
      ratingRanges: ratingRanges,
      detailRatings: detailRatings,
      reviews: reviews,
      onShowMore: getMoreUGCReviewsByShipSlug(shipSlug)
    };
  }

  return _objectSpread(_objectSpread({}, subpageProps), {}, {
    headline: "".concat((0,_utils_translation_service__WEBPACK_IMPORTED_MODULE_4__.__)('ugcHeadline')),
    title: "".concat(getLandingPage.title),
    totalRatings: numRatings,
    ratingValue: overall ? Math.round(overall * 10) / 10 : undefined,
    ratingString: ratingString,
    testimonials: testimonials,
    requestType: getLandingPage.type
  });
};

/***/ }),

/***/ 14320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ UGC; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./public/static/icons/star.svg
var star = __webpack_require__(95559);
// EXTERNAL MODULE: ./public/static/icons/thumbsUp.svg
var thumbsUp = __webpack_require__(36016);
;// CONCATENATED MODULE: ./public/static/icons/user-group.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUserGroup = function SvgUserGroup(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M24.602 28.424c2.459 0 5.032.534 7.697 1.6 2.666 1.068 3.999 2.464 3.999 4.178v5.223H12.906v-5.223c0-1.724 1.333-3.12 3.998-4.177 2.666-1.057 5.239-1.601 7.698-1.601zm13.488-3.238.502.007c2.352.067 4.803.597 7.336 1.593C48.643 27.852 50 29.246 50 30.969v5.22H37.459v-1.857c0-2.255-1.642-4.04-4.861-5.3a24.499 24.499 0 0 0-4.293-1.272 11.268 11.268 0 0 1 1.947-.974c2.714-1.067 5.334-1.6 7.838-1.6zm-26.453-.025.491.007c2.298.066 4.693.595 7.168 1.586.628.255 1.172.52 1.656.807a24.499 24.499 0 0 0-4.339 1.286c-3.05 1.214-4.641 2.915-4.744 5.056l-.005.223.01 1.98H0V30.91c0-1.705 1.326-3.094 3.979-4.156 2.652-1.062 5.212-1.593 7.658-1.593zm12.965-9.935c1.601 0 2.965.575 4.112 1.735 1.137 1.16 1.715 2.524 1.715 4.115 0 1.59-.568 2.945-1.715 4.084-1.147 1.14-2.51 1.704-4.112 1.704-1.602 0-2.965-.564-4.112-1.704-1.137-1.128-1.715-2.493-1.715-4.084 0-1.59.568-2.956 1.715-4.115 1.136-1.16 2.51-1.735 4.112-1.735zM38.08 12c1.63 0 3.03.574 4.187 1.733 1.168 1.159 1.746 2.522 1.746 4.112 0 1.589-.589 2.953-1.746 4.08-1.168 1.139-2.557 1.703-4.187 1.703-1.62 0-3.02-.564-4.188-1.702-1.168-1.139-1.746-2.492-1.746-4.081 0-1.59.589-2.953 1.746-4.112C35.06 12.574 36.45 12 38.08 12zm-26.443.03c1.594 0 2.961.572 4.092 1.726 1.141 1.154 1.707 2.512 1.707 4.095 0 1.582-.576 2.94-1.707 4.063-1.141 1.134-2.498 1.695-4.092 1.695-1.593 0-2.95-.561-4.08-1.684C6.414 20.79 5.85 19.443 5.85 17.86c0-1.583.565-2.94 1.696-4.105 1.141-1.154 2.498-1.725 4.091-1.725z"
  })));
};

/* harmony default export */ var user_group = (SvgUserGroup);
// EXTERNAL MODULE: ./src/contexts/device/device.tsx
var device = __webpack_require__(90780);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
// EXTERNAL MODULE: ./src/utils/EventTracker.ts
var EventTracker = __webpack_require__(6946);
// EXTERNAL MODULE: ./src/utils/formatting.ts
var formatting = __webpack_require__(62556);
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./src/components/atoms/highlightbar/highlightbar.tsx + 1 modules
var highlightbar = __webpack_require__(53242);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/atoms/progressbar/progressbar.style.tsx



var _excluded = ["width"],
    _excluded2 = ["color"],
    _excluded3 = ["hasBaseValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var StyledBarBackground = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1slkd9x5"
} : 0)("background-color:", function (props) {
  return props.theme.shades.lightGrey;
}, ";height:8px;width:100%;border-radius:5px;overflow:hidden;" + ( true ? "" : 0));
var StyledBarForeground = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref) {
  var width = _ref.width,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread({}, rest));
},  true ? {
  target: "e1slkd9x4"
} : 0)("background-color:", function (props) {
  return props.theme.colors.main4;
}, ";height:8px;width:", function (props) {
  return props.width;
}, "%;border-radius:5px;" + ( true ? "" : 0));
var StyledBarDescriptionContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1slkd9x3"
} : 0)( true ? {
  name: "19kdgsy",
  styles: "display:flex;justify-content:space-between;padding-top:2px;padding-bottom:10px"
} : 0);
var StyledBarDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref2) {
  var color = _ref2.color,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", _objectSpread({}, rest));
},  true ? {
  target: "e1slkd9x2"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextS;
}, ";font-weight:700;display:block;color:", function (props) {
  return props.color ? props.color : '';
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";}" + ( true ? "" : 0));
var StyledBarValue = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref3) {
  var hasBaseValue = _ref3.hasBaseValue,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded3);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", _objectSpread({}, rest));
},  true ? {
  target: "e1slkd9x1"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextS;
}, ";justify-self:flex-end;min-width:", function (props) {
  return props.hasBaseValue ? '60px' : 'initial';
}, ";text-align:right;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";min-width:initial;text-align:initial;}" + ( true ? "" : 0));
var StyledValue = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1slkd9x0"
} : 0)( true ? {
  name: "1j389vi",
  styles: "font-weight:700"
} : 0);
;// CONCATENATED MODULE: ./src/components/atoms/progressbar/progressbar.tsx





var Progressbar = function Progressbar(_ref) {
  var value = _ref.value,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? 10 : _ref$base,
      description = _ref.description,
      _ref$showBase = _ref.showBase,
      showBase = _ref$showBase === void 0 ? true : _ref$showBase,
      descriptionColor = _ref.descriptionColor;
  var calculatedBarLength = Math.ceil(value * 100 / base);
  var barLength = 100;

  if (calculatedBarLength >= 0 && calculatedBarLength <= 100) {
    barLength = calculatedBarLength;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBarBackground, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBarForeground, {
        width: barLength
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledBarDescriptionContainer, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBarDescription, {
        color: descriptionColor,
        children: description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBarValue, {
        hasBaseValue: showBase,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledValue, {
            children: value
          }), showBase && ' / ' + base]
        })
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/components/atoms/rating/rating.tsx + 3 modules
var rating = __webpack_require__(58761);
// EXTERNAL MODULE: ./src/components/atoms/section-headline/section-headline.tsx
var section_headline = __webpack_require__(87080);
;// CONCATENATED MODULE: ./public/static/icons/quote-start.svg
var quote_start_path;

function quote_start_extends() { quote_start_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return quote_start_extends.apply(this, arguments); }



var SvgQuoteStart = function SvgQuoteStart(props) {
  return /*#__PURE__*/react.createElement("svg", quote_start_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), quote_start_path || (quote_start_path = /*#__PURE__*/react.createElement("path", {
    d: "M23.225 14.355c0 10-7.42 20.646-18.226 27.581-1.774 1.13-2.742 1.13-3.71-.161l-.806-1.13c-.807-1.128-.645-1.773.806-3.064 3.065-2.742 8.226-8.548 8.226-12.58 0-4.033-4.032-6.936-4.032-10.969C5.483 8.387 9.838 5 14.515 5c5.323 0 8.71 3.871 8.71 9.355zm26.775 0c0 10-7.42 20.646-18.226 27.581-1.774 1.13-2.742 1.13-3.71-.161l-.806-1.13c-.807-1.128-.646-1.773.806-3.064 3.065-2.742 8.226-8.548 8.226-12.58 0-4.033-4.032-6.936-4.032-10.969C32.258 8.387 36.613 5 41.29 5 46.613 5 50 8.871 50 14.355z"
  })));
};

/* harmony default export */ var quote_start = (SvgQuoteStart);
;// CONCATENATED MODULE: ./src/components/molecules/testimonial-slider/testimonial-slider.style.tsx



var testimonial_slider_style_excluded = ["startQuote"];

function testimonial_slider_style_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function testimonial_slider_style_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? testimonial_slider_style_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : testimonial_slider_style_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function testimonial_slider_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var StyledComponentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evn2ae96"
} : 0)( true ? {
  name: "16peu1y",
  styles: "flex-grow:0;width:100%;height:100%;display:flex;align-items:center"
} : 0);
var StyledGalleryWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evn2ae95"
} : 0)( true ? {
  name: "128figl",
  styles: "flex-grow:0;width:100%"
} : 0);
var StyledTestimonialWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evn2ae94"
} : 0)( true ? {
  name: "yaec80",
  styles: "padding:0 40px;display:flex;flex-direction:row;width:100%"
} : 0);
var StyledContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evn2ae93"
} : 0)( true ? {
  name: "22hn37",
  styles: "display:flex;flex-direction:column;flex-grow:1;justify-content:center;margin-top:21px;text-align:center;flex:1"
} : 0);
var StyledTestimonialText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "evn2ae92"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";line-height:1.3;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";line-height:1.29;}" + ( true ? "" : 0));
var StyledTestimonialName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "evn2ae91"
} : 0)("font-size:10px;color:", function (props) {
  return props.theme.shades.midGrey;
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "ykkzue",
  styles: "align-self:flex-start;transform:rotate(-180deg)"
} : 0;

var _ref2 =  true ? {
  name: "1hz82em",
  styles: "align-self:flex-end;margin-bottom:7px"
} : 0;

var StyledQuoteIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref3) {
  var startQuote = _ref3.startQuote,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, testimonial_slider_style_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(quote_start, testimonial_slider_style_objectSpread({}, rest));
},  true ? {
  target: "evn2ae90"
} : 0)("fill:#99afbf;width:40px;flex-shrink:0;", function (props) {
  return props.startQuote ? _ref2 : _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/atoms/simple-gallery/simple-gallery.tsx + 1 modules
var simple_gallery = __webpack_require__(11178);
;// CONCATENATED MODULE: ./src/components/molecules/testimonial-slider/testimonial.tsx





var Testimonial = function Testimonial(_ref) {
  var quote = _ref.quote,
      name = _ref.name,
      time = _ref.time,
      additionalInfo = _ref.additionalInfo;

  var formattedAdditionalInfo = (0,translation_service.__)('additionalReviewInfo').replace('[additionalInfo]', additionalInfo);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledTestimonialWrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledQuoteIcon, {
      startQuote: true
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContentWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTestimonialText, {
        children: quote
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTestimonialName, {
        children: "".concat(name).concat(time || '', ", ").concat(formattedAdditionalInfo)
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledQuoteIcon, {})]
  });
};
;// CONCATENATED MODULE: ./src/components/molecules/testimonial-slider/testimonial-slider.tsx






var TestimonialSlider = function TestimonialSlider(_ref) {
  var testimonials = _ref.testimonials;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledComponentWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledGalleryWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(simple_gallery/* SimpleGallery */.P, {
        arrowColor: global_style/* theme.colors.main4 */.rS.colors.main4,
        showDots: false,
        showFadedArrow: true,
        children: testimonials.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonial, {
            quote: item.quote,
            name: item.name,
            additionalInfo: item.additionalInfo
          }, item.name + item.time);
        })
      })
    })
  });
};
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(2373);
;// CONCATENATED MODULE: ./src/hooks/useToggleContentScroll.ts

/**
 * To enable the read more/less provision for the texts and animate the collapsible behavior
 * by setting the maxHeight
 * @param {scrollableDomRef} The ref object of the html dom which needs to be  collapsible.
 */

var useToggleContentScroll = function useToggleContentScroll(scrollableDomRef) {
  var _useState = (0,react.useState)(true),
      isCollapsed = _useState[0],
      setIsCollapsed = _useState[1];

  var _useState2 = (0,react.useState)(200),
      maxHeightReviewContent = _useState2[0],
      setMaxHeightReviewContent = _useState2[1];

  var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
  useIsomorphicLayoutEffect(function () {
    if (scrollableDomRef) {
      var _maxHeightReviewContent = scrollableDomRef.current && scrollableDomRef.current.scrollHeight;

      _maxHeightReviewContent && setMaxHeightReviewContent(_maxHeightReviewContent);
    }
  }, [scrollableDomRef]);

  var toggleCollapse = function toggleCollapse() {
    setIsCollapsed(!isCollapsed);
  };

  return {
    isCollapsed: isCollapsed,
    toggleCollapse: toggleCollapse,
    maxHeightReviewContent: maxHeightReviewContent
  };
};
// EXTERNAL MODULE: ./public/static/icons/cabin.svg
var cabin = __webpack_require__(31079);
// EXTERNAL MODULE: ./src/utils/device-detection.ts
var device_detection = __webpack_require__(52756);
// EXTERNAL MODULE: ./src/components/atoms/label-box/label-box.tsx + 6 modules
var label_box = __webpack_require__(61128);
// EXTERNAL MODULE: ./src/components/molecules/offer-board-card/offer-board-card.style.tsx
var offer_board_card_style = __webpack_require__(50911);
// EXTERNAL MODULE: ./src/components/sections/highlights/highlights.style.tsx + 3 modules
var highlights_style = __webpack_require__(67250);
;// CONCATENATED MODULE: ./src/utils/ellipsis.ts
/**
 * @param text text to truncate
 * @param charLimit number of shown characters
 */
var ellipsis = function ellipsis(text, charLimit) {
  return text.length > charLimit ? text.slice(0, charLimit) + '...' : text;
};
// EXTERNAL MODULE: ./public/static/icons/plus.svg
var plus = __webpack_require__(25863);
// EXTERNAL MODULE: ./public/static/icons/minus.svg
var minus = __webpack_require__(29324);
// EXTERNAL MODULE: ./src/utils/buildVersion.ts
var buildVersion = __webpack_require__(76577);
;// CONCATENATED MODULE: ./src/components/sections/ugc/ugc.style.tsx


function ugc_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var ugc_style_StyledComponentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e19bcyh712"
} : 0)("color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";margin:0 auto;width:100%;padding-bottom:30px;@media ", global_style/* mediaQueries.phone */.w5.phone, "{background-color:", function (props) {
  return props.theme.shades.white;
}, ";margin-bottom:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing.landingComponent.small;
}, ";}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:0 15px;margin-bottom:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.landingComponent.medium;
}, ";}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{max-width:1200px;margin-bottom:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacing.landingComponent.large;
}, ";}h1{padding-top:20px;}" + ( true ? "" : 0));
var StyledHighlightList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e19bcyh711"
} : 0)("display:flex;flex-direction:column;list-style:none;padding-left:0;padding-top:10px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{flex-direction:row;width:100%;padding-top:0;}" + ( true ? "" : 0));
var StyledHighlightListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e19bcyh710"
} : 0)("display:flex;font-weight:700;align-items:center;padding:3px 0;font-size:15px;div{display:flex;align-items:center;}svg{fill:", function (props) {
  return props.theme.colors.main4;
}, ";flex-basis:25px;height:25px;width:25px;margin-right:8px;}div span{width:100%;}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:33%;justify-content:", function (props) {
  return props.align;
}, ";padding:0;}" + ( true ? "" : 0));
var StyledHighlightContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh79"
} : 0)("width:100%;background-color:", function (props) {
  return props.theme.shades.white;
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin-bottom:15px;background-color:transparent;}" + ( true ? "" : 0));
var StyledRatingWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh78"
} : 0)("display:flex;justify-content:space-evenly;background-color:", function (props) {
  return props.theme.shades.white;
}, ";@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{padding-top:20px;}" + ( true ? "" : 0));
var StyledRatingInner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh77"
} : 0)("width:100%;padding:40px 0 35px 0;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:33%;padding:40px 0 20px 0;}" + ( true ? "" : 0));
var StyledTestimonialContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh76"
} : 0)("display:none;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{display:flex;width:66%;max-width:66%;overflow:hidden;align-items:center;}" + ( true ? "" : 0)); // Bar Section

var StyledBarSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh75"
} : 0)("display:flex;align-items:baseline;background-color:", function (props) {
  return props.theme.shades.white;
}, ";padding-top:10px;@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{padding:20px 0px;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{padding:10px 15px 0;}" + ( true ? "" : 0));
var StyledBarContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh74"
} : 0)("width:50%;max-width:50%;padding-left:10px;padding-right:10px;flex-grow:1;@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{padding-left:15px;padding-right:15px;}" + ( true ? "" : 0));
var StyledOverviewContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh73"
} : 0)("display:block;width:50%;", StyledBarContainer, "{width:100%;max-width:100%;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{width:33%;}" + ( true ? "" : 0));
var StyledDetailContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh72"
} : 0)("display:flex;flex-wrap:wrap;padding-bottom:20px;width:50%;padding-bottom:0;", StyledBarContainer, "{width:100%;max-width:100%;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{width:66%;padding-bottom:0;", StyledBarContainer, "{width:50%;max-width:50%;&:nth-child(2n){padding-right:5px;}}}" + ( true ? "" : 0)); // The load more button wrapper
// @TODO move it outside that we can reuse

var ugc_style_ref =  true ? {
  name: "1680v0z",
  styles: "transform:rotate(90deg);svg{transform:rotate(0);}"
} : 0;

var StyledButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh71"
} : 0)("display:flex;justify-content:center;button{@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{min-width:170px;}}svg{", function (props) {
  return props.arrow !== 'right' && ugc_style_ref;
}, "@media ", global_style/* mediaQueries.phone */.w5.phone, "{width:13px;}}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{background-color:", function (props) {
  return props.theme.shades.white;
}, ";padding-bottom:30px;}" + ( true ? "" : 0));
var StyledSpinnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e19bcyh70"
} : 0)("text-align:center;padding:", function (props) {
  return props.theme.spacing.xxxLarge;
}, " 0;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/sections/ugc-reviews/ugc-review-item/ugc-review-item.style.tsx




var StyledUGCReviewSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "evqk5wv17"
} : 0)("max-width:1170px;margin:0 auto;background:", function (props) {
  return props.theme.shades.white;
}, ";padding:0 10px 0;@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{padding:20px 30px 0;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding:40px 30px 0;}", StyledButtonWrapper, "{padding-top:", function (props) {
  return props.theme.spacingX.tablet;
}, ";button{@media ", global_style/* mediaQueries.phone */.w5.phone, "{border:0;}span:first-child{@media ", global_style/* mediaQueries.phone */.w5.phone, "{padding:0 ", function (props) {
  return props.theme.spacingX.desktop;
}, " 0 0;}}}}" + ( true ? "" : 0));
var StyledAlReviewsHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "evqk5wv16"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";line-height:normal;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";font-weight:600;margin:0;text-align:left;padding-bottom:", function (props) {
  return props.theme.spacingX.mobile;
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding-bottom:", function (props) {
  return props.theme.spacingX.desktop;
}, ";}" + ( true ? "" : 0));
var StyledUGCArticle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "evqk5wv15"
} : 0)("display:flex;margin-bottom:", function (props) {
  return props.theme.spacing.large;
}, ";background:", function (props) {
  return props.theme.shades.white;
}, ";flex-direction:column;box-shadow:0 0 8px 0 ", function (props) {
  return props.theme.dropShadows['black-20'];
}, ";@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{min-height:315px;flex-direction:row;}>button{margin:", function (props) {
  return props.theme.spacingX.mobile;
}, " 0 ", function (props) {
  return props.theme.spacingX.desktop;
}, ";}" + ( true ? "" : 0));
var StyledRating = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv14"
} : 0)("span{font-size:25px;line-height:", function (props) {
  return props.theme.lineHeight.headlineS;
}, ";@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{font-size:40px;line-height:", function (props) {
  return props.theme.lineHeight.headlineXL;
}, ";}&:first-child{font-weight:600;}}" + ( true ? "" : 0));
var StyledAtmosphere = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "evqk5wv13"
} : 0)("margin-bottom:", function (props) {
  return props.theme.spacing.large;
}, ";display:none;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{margin-bottom:", function (props) {
  return props.theme.spacingX.desktop;
}, ";padding:0;list-style:none;display:flex;overflow:hidden;max-width:100%;flex-wrap:wrap;max-height:25px;flex-direction:row;}li{display:inline;}" + ( true ? "" : 0));
var StyledCommentParaGraph = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "evqk5wv12"
} : 0)("color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";line-height:", function (props) {
  return props.theme.lineHeight.headlineXS;
}, ";margin:0 0 0 ", function (props) {
  return props.theme.spacing.large;
}, ";@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{max-height:", function (props) {
  return props.isCollapsed ? '75px' : props.scrollContentHeight + 'px';
}, ";transition:max-height 0.5s ease;overflow-y:", function (props) {
  return props.isCollapsed ? 'hidden' : 'auto';
}, ";}" + ( true ? "" : 0));
var StyledReviewComment = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv11"
} : 0)("display:flex;margin-bottom:", function (props) {
  return props.theme.spacing.medium;
}, ";button{display:none;outline:0 none;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{display:inline-block;border:0;background:none;}}" + ( true ? "" : 0));
var StyledTextOpacity = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv10"
} : 0)("position:absolute;height:15px;bottom:0;width:calc(100% - 15px);background-image:linear-gradient(to bottom, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 1));@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{display:none;}" + ( true ? "" : 0));
var StyledCabinComment = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv9"
} : 0)("display:flex;@media ", global_style/* mediaQueries.IE10or11 */.w5.IE10or11, "{display:block;}padding-top:", function (props) {
  return props.theme.spacing.large;
}, ";border-top:2px solid #eee;margin-bottom:0;h4,p{font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";line-height:", function (props) {
  return props.theme.lineHeight.headlineXS;
}, ";margin:0;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";margin-left:", function (props) {
  return props.theme.spacing.large;
}, ";}" + ( true ? "" : 0));
var assetPrefix = (0,buildVersion/* getAssetsPrefix */.x)();
var backgroundImageUrl = "".concat(assetPrefix, "/static/user.svg");
var StyledReviewHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv8"
} : 0)("position:relative;color:", function (props) {
  return props.theme.shades.white;
}, ";@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{display:flex;flex-direction:column;justify-content:center;align-items:center;width:32%;background-image:url(", backgroundImageUrl, ");background-repeat:no-repeat;background-size:60%;background-position:center;}@media ", global_style/* mediaQueries.IE10or11 */.w5.IE10or11, "{min-height:315px;}" + ( true ? "" : 0));
var StyledReviewBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv7"
} : 0)("padding:", function (props) {
  return props.theme.spacing.large;
}, " ", function (props) {
  return props.theme.spacing.large;
}, " 0;max-height:", function (props) {
  return props.isCollapsed ? '150px' : props.scrollContentHeight + 'px';
}, ";overflow:", function (props) {
  return props.isCollapsed ? 'hidden' : 'scroll';
}, ";transition:max-height 0.5s ease;position:relative;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{max-height:", function (props) {
  return props.isCollapsed ? '120px' : props.scrollContentHeight + 'px';
}, ";}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding:20px 30px;width:68%;max-height:none;overflow:auto;}h3{font-size:", function (props) {
  return props.theme.fontSize.headlineXS;
}, ";font-weight:normal;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";margin:0 0 ", function (props) {
  return props.theme.spacing.medium;
}, ";line-height:normal;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";}}" + ( true ? "" : 0));
var StyledOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv6"
} : 0)("position:absolute;top:0;left:0;height:100%;width:100%;background:", function (props) {
  return props.theme.shades.textFadeGradient;
}, ";" + ( true ? "" : 0));
var StyledAgeRange = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv5"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";line-height:normal;font-weight:400;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextXL;
}, ";line-height:", function (props) {
  return props.theme.lineHeight.headlineM;
}, ";margin-bottom:4px;}" + ( true ? "" : 0));
var StyledName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "evqk5wv4"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";font-weight:600;line-height:normal;margin:0;", StyledAgeRange, "{padding-left:", function (props) {
  return props.theme.spacing.small;
}, ";}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextXL;
}, ";line-height:", function (props) {
  return props.theme.lineHeight.headlineL;
}, ";margin:", function (props) {
  return props.theme.spacing.large;
}, ";", function (props) {
  return props.theme.spacing.medium;
}, ";", function (props) {
  return props.theme.spacing.small;
}, ";}" + ( true ? "" : 0));
var StyledReviewDesktopHeaderContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv3"
} : 0)("position:relative;text-align:center;display:none;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{display:block;}" + ( true ? "" : 0));
var StyledReviewMobileHeaderContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "evqk5wv2"
} : 0)("display:flex;text-align:initial;position:relative;align-items:center;background-image:url(", backgroundImageUrl, ");background-repeat:no-repeat;background-position:left -5px bottom;background-size:90px;min-height:90px;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{display:none;}>div:nth-of-type(1){padding:", function (props) {
  return props.theme.spacing.large;
}, ";color:", function (props) {
  return props.theme.shades.white;
}, ";@media ", global_style/* mediaQueries.phone */.w5.phone, "{width:50%;}}>div:nth-of-type(2){margin-left:auto;padding-right:", function (props) {
  return props.theme.spacing.large;
}, ";}", StyledAgeRange, "{display:inline-block;}" + ( true ? "" : 0));
var StyledConstellation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(StyledAgeRange,  true ? {
  target: "evqk5wv1"
} : 0)( true ? "" : 0);
var StyledShowMoreBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "evqk5wv0"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";color:", function (props) {
  return props.theme.colors.main4;
}, ";font-weight:700;border:0;background:none;outline:0 none;svg{position:relative;top:2px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{display:none;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/sections/ugc-reviews/ugc-review-item/ugc-review-comment.tsx














var renderSVGIcon = function renderSVGIcon(iconType) {
  if (iconType === 'positive') {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(plus/* default */.Z, {});
  } else if (iconType === 'negative') {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(minus/* default */.Z, {});
  } else {
    return null;
  }
};

var UGCReviewComment = function UGCReviewComment(_ref) {
  var comment = _ref.comment,
      iconType = _ref.iconType;
  var device = (0,device_detection/* getDetectedDevice */.c)();
  var reviewDescRef = /*#__PURE__*/react.createRef();

  var _useToggleContentScro = useToggleContentScroll(reviewDescRef),
      isCollapsed = _useToggleContentScro.isCollapsed,
      toggleCollapse = _useToggleContentScro.toggleCollapse,
      maxHeightReviewContent = _useToggleContentScro.maxHeightReviewContent;

  var charLimit = 280;
  var normalizedText = comment && isCollapsed && device === 'desktop' ? ellipsis(comment, charLimit) : comment;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: normalizedText ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledReviewComment, {
      children: [iconType && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
        style: {
          fontSize: 15,
          color: global_style/* theme.shades.darkGrey */.rS.shades.darkGrey
        },
        children: renderSVGIcon(iconType)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCommentParaGraph, {
        ref: reviewDescRef,
        isCollapsed: isCollapsed,
        scrollContentHeight: maxHeightReviewContent,
        children: [normalizedText, ' ', normalizedText && normalizedText.length > charLimit ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledShowMoreBtn, {
          onClick: toggleCollapse,
          "aria-expanded": !isCollapsed,
          "data-testid": "toggle-comment-btn",
          children: [isCollapsed ? "mehr anzeigen" : "weniger anzeigen", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* StyledArrowIcon */.$0, {
            isCollapsed: isCollapsed
          })]
        }) : null]
      })]
    }) : null
  });
};
// EXTERNAL MODULE: ./src/utils/date.ts
var utils_date = __webpack_require__(16645);
;// CONCATENATED MODULE: ./src/components/sections/ugc-reviews/ugc-review-item/ugc-review-item.tsx
















var UgcReviewItem = function UgcReviewItem(props) {
  var _props$review = props.review,
      overallRating = _props$review.overallRating,
      name = _props$review.name,
      constellation = _props$review.constellation,
      arrival = _props$review.arrival,
      cruise = _props$review.cruise,
      atmosphere = _props$review.atmosphere,
      positivePointsComment = _props$review.positivePointsComment,
      negativePointsComment = _props$review.negativePointsComment,
      cabinType = _props$review.cabinType,
      cabinComment = _props$review.cabinComment,
      ageRange = _props$review.ageRange;
  var device = (0,device_detection/* getDetectedDevice */.c)();
  var ugcWrapperRef = /*#__PURE__*/react.createRef();

  var _useToggleContentScro = useToggleContentScroll(ugcWrapperRef),
      isCollapsed = _useToggleContentScro.isCollapsed,
      toggleCollapse = _useToggleContentScro.toggleCollapse,
      maxHeightReviewContent = _useToggleContentScro.maxHeightReviewContent;

  var date = arrival ? (0,utils_date/* formatDateDDMMMMYYYY */.iS)(arrival) : '';
  var UGCREVIEWITEM_INITIALHEIGHT = device === 'tablet' ? 120 : 150;
  var atmosIgnored = ['discreet', 'inspiring', 'stressful', 'impersonal'];
  var filteredAtmosphere = atmosphere && atmosphere.filter(function (atmosItem) {
    return !atmosIgnored.includes(atmosItem);
  });
  var formatConstellation = constellation === null || constellation === void 0 ? void 0 : constellation.replace(/[^\w\s]/gi, '');
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledUGCArticle, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledReviewHeader, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledOverlay, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledReviewMobileHeaderContent, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledName, {
            children: [name, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAgeRange, {
              children: ageRange && "(".concat(ageRange, ")")
            })]
          }), !!formatConstellation && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledConstellation, {
            children: (0,translation_service.__)("constellation".concat(formatConstellation, "Label"))
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRating, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: overallRating && overallRating.toFixed ? overallRating.toFixed(1) : ''
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
              children: " / 10"
            })]
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledReviewDesktopHeaderContent, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRating, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: overallRating && overallRating.toFixed ? overallRating.toFixed(1) : ''
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
            children: " / 10"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledName, {
          children: name
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAgeRange, {
          children: ageRange && "(".concat(ageRange, ")")
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledConstellation, {
          children: (0,translation_service.__)("constellation".concat(formatConstellation, "Label"))
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledReviewBody, {
      isCollapsed: isCollapsed,
      ref: ugcWrapperRef,
      scrollContentHeight: maxHeightReviewContent,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
        children: cruise
      }), filteredAtmosphere && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAtmosphere, {
        children: filteredAtmosphere.length > 0 && filteredAtmosphere.map(function (atmosLabel, key) {
          var labelWithAtmosphere = "atmosphere".concat(atmosLabel.toLowerCase());
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_board_card_style/* StyledTextLabelListItem */.UN, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(label_box/* LabelBox */.q, {
              type: labelWithAtmosphere,
              label: (0,translation_service.__)(labelWithAtmosphere)
            })
          }, key);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UGCReviewComment, {
        comment: positivePointsComment,
        iconType: "positive"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UGCReviewComment, {
        comment: negativePointsComment,
        iconType: "negative"
      }), cabinComment ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCabinComment, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
          style: {
            fontSize: 15,
            color: global_style/* theme.shades.darkGrey */.rS.shades.darkGrey
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cabin/* default */.Z, {})
        }), ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h4", {
            children: cabinType
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UGCReviewComment, {
            comment: cabinComment
          })]
        })]
      }) : null, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTextOpacity, {})]
    }), maxHeightReviewContent && maxHeightReviewContent > UGCREVIEWITEM_INITIALHEIGHT ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledShowMoreBtn, {
      onClick: function onClick() {
        // @TODO: set category to wharever is the parent of this thingy
        EventTracker/* eventTracker.track */.xT.track({
          event: 'click',
          category: (0,EventTracker/* getLandingPageCategory */.lG)('ugc'),
          action: (0,EventTracker/* getLandingPageActions */.Ut)('ugc'),
          label: 'see more'
        });
        return toggleCollapse();
      },
      "aria-expanded": !isCollapsed,
      "data-testid": "toggle-content-btn",
      children: [isCollapsed ? "mehr anzeigen" : "weniger anzeigen", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* StyledArrowIcon */.$0, {
        isCollapsed: isCollapsed
      })]
    }) : null]
  });
};
/* harmony default export */ var ugc_review_item = ((/* unused pure expression or super */ null && (UgcReviewItem)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(74194);
;// CONCATENATED MODULE: ./src/hooks/load-more.ts




function load_more_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function load_more_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? load_more_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : load_more_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'START_FETCH_ITEMS':
      return load_more_objectSpread(load_more_objectSpread({}, state), {}, {
        isLoading: true
      });

    case 'RECEIVE_ITEMS':
      var items = [].concat((0,toConsumableArray/* default */.Z)(state.items), (0,toConsumableArray/* default */.Z)(action.items));
      return load_more_objectSpread(load_more_objectSpread({}, state), {}, {
        items: items,
        offset: state.offset + action.items.length,
        shouldShowButton: items.length < state.totalCount,
        isLoading: false
      });

    case 'FETCH_ERROR':
      logger/* log.error */.c.error('Fetching failed at load-more reducer', action.error);
      return load_more_objectSpread(load_more_objectSpread({}, state), {}, {
        isLoading: false
      });
  }

  return state;
};
var useLoadMore = function useLoadMore(cb, itemsToFetch, initialItems, totalCount) {
  var initialState = {
    items: initialItems,
    offset: initialItems.length,
    isLoading: false,
    shouldShowButton: initialItems.length < totalCount,
    totalCount: totalCount
  };

  var _React$useReducer = react.useReducer(reducer, initialState),
      _React$useReducer2 = (0,slicedToArray/* default */.Z)(_React$useReducer, 2),
      _React$useReducer2$ = _React$useReducer2[0],
      items = _React$useReducer2$.items,
      offset = _React$useReducer2$.offset,
      shouldShowButton = _React$useReducer2$.shouldShowButton,
      isLoading = _React$useReducer2$.isLoading,
      dispatch = _React$useReducer2[1];

  var getData = function getData() {
    dispatch({
      type: 'START_FETCH_ITEMS'
    });
    cb(offset, itemsToFetch).then(function (items) {
      dispatch({
        type: 'RECEIVE_ITEMS',
        items: items
      });
    }).catch(function (error) {
      dispatch({
        type: 'FETCH_ERROR',
        error: error
      });
    });
  };

  return {
    getMoreItems: getData,
    items: items,
    shouldShowButton: shouldShowButton,
    isLoading: isLoading
  };
};
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
;// CONCATENATED MODULE: ./src/components/sections/ugc-reviews/ugc-reviews.tsx











var UgcReviews = function UgcReviews(_ref) {
  var reviews = _ref.reviews,
      onShowMore = _ref.onShowMore,
      totalCount = _ref.totalCount;

  var _useLoadMore = useLoadMore(onShowMore, 10, reviews, totalCount),
      getMoreItems = _useLoadMore.getMoreItems,
      items = _useLoadMore.items,
      shouldShowButton = _useLoadMore.shouldShowButton,
      isLoading = _useLoadMore.isLoading;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledUGCReviewSection, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAlReviewsHeader, {
      children: "Alle Bewertungen (".concat(totalCount, "):")
    }), items && items.map(function (_ref2, key) {
      var attributes = _ref2.attributes;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UgcReviewItem, {
        review: attributes
      }, key);
    }), shouldShowButton ? isLoading ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSpinnerWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularProgress/* default */.Z, {
        thickness: 6,
        size: 25,
        style: {
          color: global_style/* theme.colors.main4 */.rS.colors.main4
        }
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
        tertiary: true,
        style: {
          color: global_style/* theme.colors.main4 */.rS.colors.main4,
          borderColor: global_style/* theme.colors.main4 */.rS.colors.main4,
          backgroundColor: 'transparent'
        },
        onClick: function onClick() {
          return getMoreItems();
        },
        children: (0,translation_service.__)('loadMore')
      })
    }) : null]
  });
};
/* harmony default export */ var ugc_reviews = (UgcReviews);
;// CONCATENATED MODULE: ./src/components/sections/ugc/ugc.tsx



















var UGC = function UGC(_ref) {
  var title = _ref.title,
      headline = _ref.headline,
      totalRatings = _ref.totalRatings,
      ratingRanges = _ref.ratingRanges,
      detailRatings = _ref.detailRatings,
      ratingValue = _ref.ratingValue,
      ratingString = _ref.ratingString,
      testimonials = _ref.testimonials,
      href = _ref.href,
      buttonText = _ref.buttonText,
      reviews = _ref.reviews,
      onShowMore = _ref.onShowMore;
  var detectedDevice = react.useContext(device/* DeviceContext */.Tp);
  var secondaryDetailRatings = detailRatings ? detectedDevice === 'desktop' ? detailRatings : detailRatings.slice(0, 5) : [];

  if (!totalRatings || totalRatings === 0) {
    return null;
  }

  var nonEmptyTestimonials = (testimonials === null || testimonials === void 0 ? void 0 : testimonials.filter(function (item) {
    return Boolean(item.quote);
  })) || [];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ugc_style_StyledComponentWrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(section_headline/* SectionHeadline */.A, {
      headerType: reviews ? 'h1' : 'h2',
      firstChunk: title || '',
      secondChunk: headline + " (".concat((0,formatting/* numberFormat */.Y4)(totalRatings), ")"),
      paddingBottom: 10
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightContainer, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlightbar/* Highlightbar */.w, {
        headline: (0,translation_service.__)('ugcUSPHeadline'),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHighlightList, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightListItem, {
            align: 'flex-start',
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(user_group, {}), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: (0,translation_service.__)('ugcUSP1')
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightListItem, {
            align: 'center',
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(thumbsUp/* default */.Z, {}), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: (0,translation_service.__)('ugcUSP2')
              })]
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightListItem, {
            align: 'flex-end',
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(star/* default */.Z, {}), " ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: (0,translation_service.__)('ugcUSP3')
              })]
            })
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRatingWrapper, {
      children: [!!ratingValue && ratingString && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRatingInner, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(rating/* Rating */.i, {
          value: ratingValue,
          string: ratingString,
          amount: totalRatings,
          size: "L"
        })
      }), !!nonEmptyTestimonials.length && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTestimonialContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider, {
          testimonials: nonEmptyTestimonials
        })
      })]
    }), ratingRanges && ratingRanges.length > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledBarSection, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledOverviewContainer, {
        children: ratingRanges === null || ratingRanges === void 0 ? void 0 : ratingRanges.map(function (rating) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBarContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Progressbar, {
              value: rating.value,
              base: totalRatings,
              description: rating.description,
              showBase: false,
              descriptionColor: global_style/* theme.colors.main4 */.rS.colors.main4
            })
          }, rating.description);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDetailContainer, {
        children: secondaryDetailRatings.map(function (rating) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBarContainer, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Progressbar, {
              value: rating.value,
              description: rating.description
            })
          }, rating.description);
        })
      })]
    }), href && buttonText && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonWrapper, {
      arrow: "right",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
        tertiary: true,
        style: {
          color: global_style/* theme.colors.main4 */.rS.colors.main4,
          borderColor: global_style/* theme.colors.main4 */.rS.colors.main4,
          backgroundColor: 'transparent'
        },
        redirectUrl: href,
        onClick: function onClick() {
          return EventTracker/* eventTracker.track */.xT.track({
            event: 'click',
            category: 'link-to-subpage',
            action: 'ugc-module',
            label: "ship-".concat(title)
          });
        },
        children: buttonText
      })
    }), reviews && onShowMore && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ugc_reviews, {
      reviews: reviews,
      totalCount: totalRatings,
      onShowMore: onShowMore
    })]
  });
};

/***/ })

}]);